import { useEffect, useState } from 'react';

//import Component
import PageForm from 'components/pageForm/PageForm';
import ApiDatabase from 'server';
import AdminCollapse from '../../components/collapse/AdminCollapse';
import useContext from '../../hooks/useContext';
import useWindowDimensions from '../../hooks/useWindowDimensions';

const IdentityValidation = () => {
  const [tempWorkers, setTempWorkers] = useState([]);
  const [tempWorker, setTempWorker] = useState([]);
  const { updateTempWorker, setUpdateTempWorker } = useContext();
  const token = localStorage.getItem('xsrfToken');
  const { height, width } = useWindowDimensions();
  const [isWaiting, setIsWaiting] = useState(true);

  const getTempWorkers = () => {
    ApiDatabase.getAllUsersWithIdentityFilesToComplete(
      { token: token },
      (data) => {
        setTempWorkers(data);
        setIsWaiting(false);
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.error(err);
        }
      }
    );
  };

  useEffect(() => {
    if (updateTempWorker) {
      ApiDatabase.getUserWithIdentityFilesToComplete(
        { token: token, idTempWorker: updateTempWorker },
        (data) => {
          setTempWorker(data);
          setUpdateTempWorker(false);
        },
        (err) => {
          if (err.name !== 'CanceledError') {
            console.error(err);
          }
        }
      );
    }
  }, [updateTempWorker]);

  useEffect(() => {
    getTempWorkers();
  }, []);

  /*useEffect(() => {
        if(updateTempWorker){
            setTimeout(() => {
                getTempWorkers();
                setUpdateTempWorker(false);
            }, 500);
        }
    }, [updateTempWorker]);*/

  return (
    <>
      <PageForm>
        <div className={'col-span-12 md:m-8'}>
          {isWaiting ? (
            <>
              <div className={'mb-4 text-lg font-bold'}>
                <div className={'h-3 bg-gray-200 rounded w-20'}></div>
              </div>
              <div
                className={`${width > 768 ? 'flex flex-col gap-4' : 'flex'}`}
              >
                {[1, 2, 3, 4, 5].map((i, index) => (
                  <AdminCollapse
                    key={index}
                    tempWorker={i}
                    tempWorkerToEdit={i}
                    isWaiting={isWaiting}
                  />
                ))}
              </div>
            </>
          ) : (
            <>
              {tempWorkers.length > 0 ? (
                <>
                  <div className={'mb-4 text-lg font-bold'}>
                    Total : {tempWorkers.length}
                  </div>
                  <div
                    className={`${
                      width > 768 ? 'flex flex-col gap-4' : 'flex'
                    }`}
                  >
                    {tempWorkers.map((tempWorkerInfos, index) => (
                      <AdminCollapse
                        key={index}
                        tempWorker={tempWorkerInfos}
                        tempWorkerToEdit={tempWorker}
                      />
                    ))}
                  </div>
                </>
              ) : (
                'Aucun utilisateur'
              )}
            </>
          )}
        </div>
      </PageForm>
    </>
  );
};

export default IdentityValidation;
